import React from 'react';
import Dialog from '../../../../core/layout/Dialog';
import PropTypes from 'prop-types';
import Row from '../../../../core/layout/Row';
import Button from '../../../../core/form/Button';
import Column from '../../../../core/layout/Column';
import Select from '../../../../core/form/Select';
import get from 'lodash/get';
import range from 'lodash/range';
import FetchSelect from '../../../../core/form/FetchSelect';
import { Roles } from '../../../../core/util';

const AddExistingUnitFormDialog = (props) => (
  <Dialog
    title="Add Existing Unit"
    isOpen={props.isOpen}
    width={800}
    onCancel={props.onCancel}
    actions={[
      <Button
        icon="reload"
        label="Cancel"
        key="cancel"
        onClick={props.onCancel}
        loading={props.submitting}
        disabled={props.submitting}
      />,
      <Button
        icon="check"
        label="Save"
        key="divide"
        onClick={props.onSave}
        loading={props.submitting}
        disabled={props.submitting}
      />,
    ]}
  >
    {[Roles.ADMIN, Roles.CONTENT_ADMIN].includes(localStorage.role) && (
      <Row>
        <Column size={4}>
          <FetchSelect
            url="distributors"
            label="Distributor"
            disabled={props.values.id || props.submitting}
            value={get(props.values, 'distributor', '')}
            onChange={(distributor) => {
              props.onChange('distributor', distributor);
            }}
            errorText={get(props.errors, 'distributor', '')}
            resultTransformer={{
              text: 'name',
              value: 'id',
            }}
          />
        </Column>
      </Row>
    )}
    <Row>
      <Column size={8}>
        <FetchSelect
          required
          showSearch
          url="available-units"
          params={{
            distributor: get(props.values, 'distributor', ''),
          }}
          disabled={!get(props.values, 'distributor', false)}
          label="Unit"
          value={get(props.values, 'unit', '')}
          onChange={(value) => props.onChange('unit', value)}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
      <Column size={2}>
        <Select
          required
          options={['A', 'B', 'C', 'D'].map((value) => ({
            value,
            label: value,
          }))}
          disabled={props.submitting || props.disabled}
          label="Group"
          value={get(props.values, 'group', '')}
          onChange={(value) => props.onChange('group', value)}
          errorText={get(props.errors, 'group', '')}
        />
      </Column>
      <Column size={2}>
        <Select
          required
          options={range(1, 41).map((value) => ({
            value,
            label: value.toString(),
          }))}
          disabled={props.submitting || props.disabled}
          label="Order"
          value={get(props.values, 'order', '')}
          onChange={(value) => props.onChange('order', value)}
          errorText={get(props.errors, 'order', '')}
        />
      </Column>
    </Row>
  </Dialog>
);

AddExistingUnitFormDialog.propTypes = {
  isOpen: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  values: PropTypes.object,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
};

AddExistingUnitFormDialog.defaultProps = {
  isOpen: false,
  values: {},
  errors: {},
  submitting: false,
};

export default AddExistingUnitFormDialog;
